// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"index_breadcrumbs_tiAye","current":"index_current_ERr96","arrow":"index_arrow_Fdn6j"};